/**
 * useApp — convenience hook for reading shared app data.
 *
 * Usage in any page:
 *   import { useApp } from '../hooks/useApp';
 *   const { s, c, proj, up } = useApp();
 *
 * This is a thin wrapper around useContext(AppContext).
 * It will throw a clear error if used outside the provider.
 */
import { useContext } from "react";
import { AppContext } from '../context/AppContext';

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) {
    throw new Error("useApp() must be used inside <AppContext.Provider>. Wrap your app in the provider in app.jsx.");
  }
  return ctx;
}
